import gsap from 'gsap';
export function shargeLoadScript(when, src, callback) {
    return new Promise((resolve, reject) => {
        if (when()) {
            // 如果条件满足，检查脚本是否已经加载
            const existingScript = document.querySelector(`script[src="${src}"]`);
            if (existingScript) {
                resolve();
                return;
            }
            // 创建并加载脚本
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => {
                callback();
                resolve();
            };
            script.onerror = () => {
                reject(new Error(`Failed to load script: ${src}`));
            };
            document.head.appendChild(script);
        }
        else {
            // 如果条件不满足，直接解决 Promise
            resolve();
        }
    });
}
(() => {
    const svg = `
<style>
  :host {
    display: inline-block;
    line-height: 0;
  }
  :host path {
    transition: fill 0.3s ease;
  }
  :host svg {
    aspect-ratio: 146 / 32;
    max-height: 100%;
    max-width: 100%;
  }
</style>
<svg
    class="sharge-animated-logo-svg"
    width="146"
    height="32"
    viewBox="0 0 146 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      data-name="left"
      d="M10.3857 19.1341L6.98121 17.0286L15.8293 2.7218L11.4249 0L0 18.4786L7.80591 23.306L10.3857 19.1341Z"
    ></path>
    <path
      d="M14.9895 8.73331L12.443 12.8538L15.8686 14.9714L7.02051 29.2782L11.4219 32L22.8166 13.5757L14.9895 8.73331Z"
      data-name="right"
    />
    <path
      d="M42.1623 14.9956H35.4982C35.0031 14.9759 34.5347 14.7654 34.1913 14.408C33.8479 14.0507 33.6561 13.5744 33.6561 13.0788C33.6561 12.5832 33.8479 12.1069 34.1913 11.7496C34.5347 11.3923 35.0031 11.1817 35.4982 11.1621H45.8779V7.88445H35.172C34.4793 7.86774 33.7903 7.98974 33.1455 8.24328C32.5006 8.49681 31.913 8.87675 31.4172 9.36075C30.9214 9.84474 30.5274 10.423 30.2584 11.0615C29.9894 11.7001 29.8508 12.3859 29.8508 13.0788C29.8508 13.7717 29.9894 14.4576 30.2584 15.0961C30.5274 15.7346 30.9214 16.3129 31.4172 16.7969C31.913 17.2809 32.5006 17.6608 33.1455 17.9144C33.7903 18.1679 34.4793 18.2899 35.172 18.2732H41.8179C42.3266 18.2732 42.8146 18.4753 43.1743 18.835C43.534 19.1948 43.7361 19.6827 43.7361 20.1914C43.7361 20.7002 43.534 21.1881 43.1743 21.5478C42.8146 21.9076 42.3266 22.1097 41.8179 22.1097H30.6709V25.3752H42.1502C42.8325 25.3752 43.5082 25.2408 44.1386 24.9797C44.769 24.7186 45.3417 24.3359 45.8242 23.8534C46.3067 23.3709 46.6894 22.7981 46.9506 22.1677C47.2117 21.5373 47.3461 20.8617 47.3461 20.1794C47.3461 19.497 47.2117 18.8214 46.9506 18.191C46.6894 17.5606 46.3067 16.9878 45.8242 16.5053C45.3417 16.0228 44.769 15.6401 44.1386 15.379C43.5082 15.1179 42.8325 14.9835 42.1502 14.9835L42.1623 14.9956Z"
      data-name="s"
    ></path>
    <path
      d="M63.2539 14.9986H53.2729V7.91162H49.666V25.3662H53.2729V18.2762H63.2539V25.3662H66.8608V7.91162H63.2539V14.9986Z"
      data-name="h"
    />
    <path
      d="M75.8871 7.91165L68.7307 25.3753H72.6306L74.422 21.0041H82.6539L84.4452 25.3753H88.3482L81.1888 7.90259L75.8871 7.91165ZM75.7693 17.7295L78.5425 10.9657L81.3096 17.7295H75.7693Z"
      data-name="a"
    />
    <path
      d="M107.18 13.4126C107.18 11.9537 106.601 10.5545 105.569 9.52282C104.537 8.49119 103.138 7.91162 101.679 7.91162H90.218V25.3752H93.8431V18.9136H98.9785L103.918 25.3752H108.47L103.313 18.6629C104.433 18.3139 105.412 17.6164 106.108 16.672C106.804 15.7275 107.179 14.5856 107.18 13.4126ZM101.293 15.6269H93.828V11.0684H101.293C101.883 11.0899 102.441 11.3394 102.851 11.7645C103.261 12.1896 103.49 12.7571 103.49 13.3477C103.49 13.9382 103.261 14.5057 102.851 14.9308C102.441 15.3559 101.883 15.6054 101.293 15.6269Z"
      data-name="r"
    />
    <path
      d="M117.593 18.2672H122.647V22.1067H117.487C114.421 22.1067 112.524 19.2671 112.524 16.6359C112.524 14.0047 114.421 11.1772 117.487 11.1772H126.218V7.88143H117.155C116.005 7.87897 114.868 8.12839 113.824 8.61217C112.78 9.09594 111.855 9.80234 111.113 10.6818C109.702 12.3439 108.927 14.4537 108.927 16.6344C108.927 18.8151 109.702 20.9248 111.113 22.587C111.855 23.4669 112.78 24.1736 113.824 24.6574C114.867 25.1413 116.005 25.3904 117.155 25.3873H126.242V14.9895H117.593V18.2672Z"
      data-name="g"
    />
    <path
      d="M132.731 18.2672H143.545V14.9895H132.731V11.1621H144.92V7.88446H129.124V25.3873H145.086V22.1097H132.731V18.2672Z"
      data-name="e"
    />
  </svg>
`;
    const SOURCE_PATH = [
        'M10.3857 19.1341L6.98121 17.0286L15.8293 2.7218L11.4249 0L0 18.4786L7.80591 23.306L10.3857 19.1341Z',
        'M14.9895 8.73331L12.443 12.8538L15.8686 14.9714L7.02051 29.2782L11.4219 32L22.8166 13.5757L14.9895 8.73331Z',
        'M42.1623 14.9956H35.4982C35.0031 14.9759 34.5347 14.7654 34.1913 14.408C33.8479 14.0507 33.6561 13.5744 33.6561 13.0788C33.6561 12.5832 33.8479 12.1069 34.1913 11.7496C34.5347 11.3923 35.0031 11.1817 35.4982 11.1621H45.8779V7.88445H35.172C34.4793 7.86774 33.7903 7.98974 33.1455 8.24328C32.5006 8.49681 31.913 8.87675 31.4172 9.36075C30.9214 9.84474 30.5274 10.423 30.2584 11.0615C29.9894 11.7001 29.8508 12.3859 29.8508 13.0788C29.8508 13.7717 29.9894 14.4576 30.2584 15.0961C30.5274 15.7346 30.9214 16.3129 31.4172 16.7969C31.913 17.2809 32.5006 17.6608 33.1455 17.9144C33.7903 18.1679 34.4793 18.2899 35.172 18.2732H41.8179C42.3266 18.2732 42.8146 18.4753 43.1743 18.835C43.534 19.1948 43.7361 19.6827 43.7361 20.1914C43.7361 20.7002 43.534 21.1881 43.1743 21.5478C42.8146 21.9076 42.3266 22.1097 41.8179 22.1097H30.6709V25.3752H42.1502C42.8325 25.3752 43.5082 25.2408 44.1386 24.9797C44.769 24.7186 45.3417 24.3359 45.8242 23.8534C46.3067 23.3709 46.6894 22.7981 46.9506 22.1677C47.2117 21.5373 47.3461 20.8617 47.3461 20.1794C47.3461 19.497 47.2117 18.8214 46.9506 18.191C46.6894 17.5606 46.3067 16.9878 45.8242 16.5053C45.3417 16.0228 44.769 15.6401 44.1386 15.379C43.5082 15.1179 42.8325 14.9835 42.1502 14.9835L42.1623 14.9956Z',
        'M63.2539 14.9986H53.2729V7.91162H49.666V25.3662H53.2729V18.2762H63.2539V25.3662H66.8608V7.91162H63.2539V14.9986Z',
        'M75.8871 7.91165L68.7307 25.3753H72.6306L74.422 21.0041H82.6539L84.4452 25.3753H88.3482L81.1888 7.90259L75.8871 7.91165ZM75.7693 17.7295L78.5425 10.9657L81.3096 17.7295H75.7693Z',
        'M107.18 13.4126C107.18 11.9537 106.601 10.5545 105.569 9.52282C104.537 8.49119 103.138 7.91162 101.679 7.91162H90.218V25.3752H93.8431V18.9136H98.9785L103.918 25.3752H108.47L103.313 18.6629C104.433 18.3139 105.412 17.6164 106.108 16.672C106.804 15.7275 107.179 14.5856 107.18 13.4126ZM101.293 15.6269H93.828V11.0684H101.293C101.883 11.0899 102.441 11.3394 102.851 11.7645C103.261 12.1896 103.49 12.7571 103.49 13.3477C103.49 13.9382 103.261 14.5057 102.851 14.9308C102.441 15.3559 101.883 15.6054 101.293 15.6269Z',
        'M117.593 18.2672H122.647V22.1067H117.487C114.421 22.1067 112.524 19.2671 112.524 16.6359C112.524 14.0047 114.421 11.1772 117.487 11.1772H126.218V7.88143H117.155C116.005 7.87897 114.868 8.12839 113.824 8.61217C112.78 9.09594 111.855 9.80234 111.113 10.6818C109.702 12.3439 108.927 14.4537 108.927 16.6344C108.927 18.8151 109.702 20.9248 111.113 22.587C111.855 23.4669 112.78 24.1736 113.824 24.6574C114.867 25.1413 116.005 25.3904 117.155 25.3873H126.242V14.9895H117.593V18.2672Z',
        'M132.731 18.2672H143.545V14.9895H132.731V11.1621H144.92V7.88446H129.124V25.3873H145.086V22.1097H132.731V18.2672Z',
    ];
    const TARGE_PATH = [
        'M15.9471 5.04145L11.9442 5.02293L11.8664 21.8446L6.68887 21.8188L6.79218 0.0937707L15.9701 0.136457L15.9471 5.04145Z',
        'M135.794 31.9542L135.817 27.1103L139.845 27.1298L139.923 10.3082L145.097 10.3323L144.997 31.9953L135.794 31.9542Z',
        'M31.3114 14.9956H24.6474C24.1522 14.9759 23.6839 14.7654 23.3405 14.408C22.9971 14.0507 22.8053 13.5744 22.8053 13.0788C22.8053 12.5832 22.9971 12.1069 23.3405 11.7496C23.6839 11.3923 24.1522 11.1817 24.6474 11.1621H35.0271V7.88445H24.3212C23.6285 7.86774 22.9395 7.98974 22.2946 8.24328C21.6498 8.49681 21.0622 8.87675 20.5664 9.36075C20.0706 9.84474 19.6766 10.423 19.4076 11.0615C19.1386 11.7001 19 12.3859 19 13.0788C19 13.7717 19.1386 14.4576 19.4076 15.0961C19.6766 15.7346 20.0706 16.3129 20.5664 16.7969C21.0622 17.2809 21.6498 17.6608 22.2946 17.9144C22.9395 18.1679 23.6285 18.2899 24.3212 18.2732H30.9671C31.4758 18.2732 31.9637 18.4753 32.3235 18.835C32.6832 19.1948 32.8853 19.6827 32.8853 20.1914C32.8853 20.7002 32.6832 21.1881 32.3235 21.5478C31.9637 21.9076 31.4758 22.1097 30.9671 22.1097H19.8201V25.3752H31.2994C31.9817 25.3752 32.6573 25.2408 33.2877 24.9797C33.9181 24.7186 34.4909 24.3359 34.9734 23.8534C35.4559 23.3709 35.8386 22.7981 36.0997 22.1677C36.3608 21.5373 36.4952 20.8617 36.4952 20.1794C36.4952 19.497 36.3608 18.8214 36.0997 18.191C35.8386 17.5606 35.4559 16.9878 34.9734 16.5053C34.4909 16.0228 33.9181 15.6401 33.2877 15.379C32.6573 15.1179 31.9817 14.9835 31.2994 14.9835L31.3114 14.9956Z',
        'M52.403 14.9986H42.4221V7.91162H38.8152V25.3662H42.4221V18.2762H52.403V25.3662H56.0099V7.91162H52.403V14.9986Z',
        'M65.0363 7.91159L57.8799 25.3752H61.7798L63.5712 21.004H71.803L73.5944 25.3752H77.4974L70.3379 7.90253L65.0363 7.91159ZM64.9185 17.7294L67.6916 10.9657L70.4588 17.7294H64.9185Z',
        'M96.3293 13.4126C96.3293 11.9537 95.7498 10.5545 94.7181 9.52282C93.6865 8.49119 92.2873 7.91162 90.8283 7.91162H79.3672V25.3752H82.9922V18.9136H88.1277L93.0668 25.3752H97.6192L92.4626 18.6629C93.5825 18.3139 94.5616 17.6164 95.2571 16.672C95.9527 15.7275 96.3284 14.5856 96.3293 13.4126ZM90.4417 15.6269H82.9771V11.0684H90.4417C91.0318 11.0899 91.5906 11.3394 92.0005 11.7645C92.4104 12.1896 92.6394 12.7571 92.6394 13.3477C92.6394 13.9382 92.4104 14.5057 92.0005 14.9308C91.5906 15.3559 91.0318 15.6054 90.4417 15.6269Z',
        'M106.742 18.2672H111.796V22.1067H106.637C103.57 22.1067 101.673 19.2671 101.673 16.6359C101.673 14.0047 103.57 11.1772 106.637 11.1772H115.367V7.88143H106.304C105.154 7.87897 104.017 8.12839 102.973 8.61217C101.929 9.09594 101.004 9.80234 100.263 10.6818C98.8509 12.3439 98.0759 14.4537 98.0759 16.6344C98.0759 18.8151 98.8509 20.9248 100.263 22.587C101.004 23.4669 101.929 24.1736 102.973 24.6574C104.017 25.1413 105.154 25.3904 106.304 25.3873H115.391V14.9895H106.742V18.2672Z',
        'M121.88 18.2671H132.695V14.9895H121.88V11.162H134.069V7.8844H118.273V25.3873H134.235V22.1096H121.88V18.2671Z',
    ];
    const SOURCE_COLOR = 'black';
    const TARGET_COLOR = '#A6C911';
    const DURATION = 300;
    class ShargeAnimatedLogo extends HTMLElement {
        constructor() {
            super();
            // 创建 Shadow DOM
            this.attachShadow({ mode: 'open' });
            // 将 SVG 内容添加到 Shadow DOM
            this.shadowRoot.innerHTML = svg;
            // 从 Shadow DOM 中获取路径元素
            this.paths = this.shadowRoot.querySelectorAll('path');
            // 设置初始颜色
            this.paths.forEach((path) => {
                path.style.fill = SOURCE_COLOR;
            });
            this.addEventListener('mouseenter', () => {
                for (let i = 0; i < this.paths.length; i++) {
                    gsap.to(this.paths[i], {
                        attr: { d: TARGE_PATH[i] },
                        duration: DURATION / 1000, // GSAP 使用秒为单位
                        ease: 'power2.out',
                    });
                    // 使用CSS transition处理颜色变化
                    this.paths[i].style.fill = TARGET_COLOR;
                }
            });
            this.addEventListener('mouseleave', () => {
                // 使用 GSAP 回到原始状态
                for (let i = 0; i < this.paths.length; i++) {
                    gsap.to(this.paths[i], {
                        attr: { d: SOURCE_PATH[i] },
                        duration: DURATION / 1000, // GSAP 使用秒为单位
                        ease: 'power2.out',
                    });
                    // 使用CSS transition处理颜色变化
                    this.paths[i].style.fill = SOURCE_COLOR;
                }
            });
        }
    }
    customElements.define('sharge-animated-logo', ShargeAnimatedLogo);
})();
customElements.define('sharge-v-sign', class extends HTMLElement {
    constructor() {
        super();
        this.disposer = [];
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
<style>
:host {
  display: inline-block;
  position: relative;
}

.shot-area {
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
}

.left, .right {
  transition: all 0.3s ease-in-out;
  will-change: transform, opacity;
  opacity: 0;
  position: absolute;
  aspect-ratio: 6/15;
  width: 1em;
  height: 1em;
}

.left {
  transform: translate(-0.5em, -0.5em);
  top: 0;
  left: -1em;
}

.right {
  transform: translate(0.5em, 0.5em);
  bottom: 0;
  right: -1em;
}

.shot-area.active .left {
  opacity: 1;
  transform: translate(0, 0);
}

.shot-area.active .right {
  opacity: 1;
  transform: translate(0, 0);
}


</style>
<div class="shot-area">
  <svg class="left" width="6" height="15" viewBox="0 0 6 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0V15H3V3H6V0H0Z" fill="#A6C911"/>
  </svg>
  <svg class="right"  width="6" height="15" viewBox="0 0 6 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 15L6 9.53674e-07L3 6.91406e-07L3 12L-1.16824e-06 12L-1.43051e-06 15L6 15Z" fill="#A6C911"/>
  </svg>
</div>
<slot></slot>
      `;
    }
    connectedCallback() {
        this.initialSlot();
        const area = this.shadowRoot.querySelector('.shot-area');
        const controls = this.getAttribute('aria-controls');
        let hoverTarget = null;
        if (controls) {
            const target = document.getElementById(controls);
            if (target) {
                hoverTarget = target;
            }
            else {
                console.warn(`[sharge-v-sign] aria-controls(${controls}) not found`, this);
            }
        }
        // oxlint-disable-next-line no-this-alias
        hoverTarget !== null && hoverTarget !== void 0 ? hoverTarget : (hoverTarget = this);
        hoverTarget.addEventListener('mouseenter', () => {
            area.classList.add('active');
        });
        hoverTarget.addEventListener('mouseleave', () => {
            area.classList.remove('active');
        });
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
    initialSlot() {
        const slot = this.shadowRoot.querySelector('slot');
        const area = this.shadowRoot.querySelector('.shot-area');
        let capturedElement = null;
        const watchSlot = () => {
            if (!capturedElement) {
                return;
            }
            const offsetX = capturedElement.offsetLeft;
            const offsetY = capturedElement.offsetTop;
            const width = capturedElement.offsetWidth;
            const height = capturedElement.offsetHeight;
            area.style.width = `${width}px`;
            area.style.height = `${height}px`;
            area.style.left = `${offsetX}px`;
            area.style.top = `${offsetY}px`;
            const style = getComputedStyle(capturedElement);
            const fontSize = style.fontSize;
            area.style.fontSize = fontSize;
        };
        const resizeObserver = new ResizeObserver(watchSlot);
        this.disposer.push(() => resizeObserver.disconnect());
        const observe = (element) => {
            if (capturedElement) {
                resizeObserver.unobserve(capturedElement);
            }
            capturedElement = element;
            resizeObserver.observe(element);
        };
        const elements = slot.assignedElements();
        if (elements.length) {
            observe(elements[0]);
        }
        else {
            console.warn(`[sharge-v-sign] No elements in slot`, this);
        }
        slot.addEventListener('slotchange', () => {
            const elements = slot.assignedElements();
            if (elements.length) {
                observe(elements[0]);
            }
        });
    }
});
customElements.define('sharge-toggle-image', class extends HTMLElement {
    constructor() {
        super(...arguments);
        this.disposer = [];
    }
    connectedCallback() {
        const img = this.querySelector('img');
        if (!img) {
            return;
        }
        const activeSrc = img.dataset.activeIcon;
        if (!activeSrc) {
            return;
        }
        const sourceSrc = img.src;
        const target = this.getAttribute('target');
        // oxlint-disable-next-line no-this-alias
        let host = this;
        if (target) {
            const targetElement = this.closest(target);
            if (targetElement) {
                host = targetElement;
            }
        }
        if (this.hasAttribute('active-on-mobile')) {
            const query = window.matchMedia('(max-width: 768px)');
            const handle = () => {
                if (query.matches) {
                    img.src = activeSrc;
                }
                else {
                    img.src = sourceSrc;
                }
            };
            query.addEventListener('change', handle);
            this.disposer.push(() => query.removeEventListener('change', handle));
            handle();
        }
        host.addEventListener('mouseenter', () => {
            img.src = activeSrc;
        });
        host.addEventListener('mouseleave', () => {
            img.src = sourceSrc;
        });
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
});
class ShargeTestimonialsKol extends HTMLElement {
    constructor() {
        super(...arguments);
        this.disposer = [];
        this.isOverflowing = false;
        this.currentIndex = 0;
        this.watchScroll = () => {
            // 计算当前激活的元素索引 - 找到距离视口左侧边缘最近的元素
            const children = Array.from(this.children);
            if (children.length === 0)
                return;
            const containerLeft = this.scrollLeft;
            const containerRight = containerLeft + this.clientWidth;
            const containerCenter = containerLeft + this.clientWidth / 2;
            let newCurrentIndex = 0;
            let minDistance = Infinity;
            // 找到距离容器中位线最近的可见元素
            children.forEach((child, index) => {
                const childLeft = child.offsetLeft;
                const childRight = childLeft + child.offsetWidth;
                // 检查元素是否在视口内（至少部分可见）
                const isVisible = childRight > containerLeft && childLeft < containerRight;
                if (isVisible) {
                    // 计算元素中心到容器中位线的距离
                    const childCenter = childLeft + child.offsetWidth / 2;
                    const distance = Math.abs(childCenter - containerCenter);
                    if (distance < minDistance) {
                        minDistance = distance;
                        newCurrentIndex = index;
                    }
                }
            });
            // 如果索引发生变化，更新并触发事件
            if (this.currentIndex !== newCurrentIndex) {
                this.currentIndex = newCurrentIndex;
                this.dispatchEvent(new CustomEvent('current-change', {
                    detail: {
                        current: this.currentIndex,
                        length: this.length,
                    },
                }));
            }
        };
        this.watchResize = () => {
            const isOverflowing = this.scrollWidth > this.clientWidth;
            if (this.isOverflowing !== isOverflowing) {
                this.isOverflowing = isOverflowing;
                this.dispatchEvent(new CustomEvent('overflow-change', {
                    detail: {
                        overflow: this.isOverflowing,
                    },
                }));
            }
        };
    }
    get length() {
        return this.childElementCount;
    }
    get current() {
        return this.currentIndex;
    }
    connectedCallback() {
        const resizeObserver = new ResizeObserver(this.watchResize);
        resizeObserver.observe(this);
        this.disposer.push(() => resizeObserver.disconnect());
        const scrollWatch = window.theme.utils.debounce(this.watchScroll, 10);
        this.addEventListener('scroll', scrollWatch);
        this.disposer.push(() => this.removeEventListener('scroll', scrollWatch));
        this.watchResize();
        this.watchScroll();
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
    show(index) {
        const children = Array.from(this.children);
        const child = children[index];
        this.scrollTo({
            left: child.offsetLeft,
            behavior: 'smooth',
        });
    }
}
customElements.define('sharge-testimonials-kol', ShargeTestimonialsKol);
customElements.define('sharge-testimonials-kol-pagination', class extends HTMLElement {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.index = 0;
        this.disposer = [];
        this.handleClick = (e) => {
            const target = e.target;
            const index = parseInt(target.getAttribute('aria-colindex'));
            if (Number.isNaN(index)) {
                return;
            }
            this.kol.show(index - 1);
        };
        this.watchOverflow = () => {
            this.visible = this.kol.isOverflowing;
            this.setAttribute('aria-hidden', this.visible ? 'false' : 'true');
        };
        this.watchCurrent = () => {
            var _a, _b;
            this.index = this.kol.current;
            (_a = this.querySelector('[aria-current=true]')) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-current');
            (_b = this.children[this.index]) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-current', 'true');
        };
    }
    connectedCallback() {
        const controls = this.getAttribute('aria-controls');
        if (!controls) {
            throw new Error('aria-controls is required');
        }
        const kol = document.getElementById(controls);
        if (!(kol instanceof ShargeTestimonialsKol)) {
            throw new Error('aria-controls must be a sharge-testimonials-kol');
        }
        this.kol = kol;
        this.kol.addEventListener('overflow-change', this.watchOverflow);
        this.disposer.push(() => this.kol.removeEventListener('overflow-change', this.watchOverflow));
        this.kol.addEventListener('current-change', this.watchCurrent);
        this.disposer.push(() => this.kol.removeEventListener('current-change', this.watchCurrent));
        this.addEventListener('click', this.handleClick);
        this.disposer.push(() => this.removeEventListener('click', this.handleClick));
        this.watchOverflow();
        this.watchCurrent();
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
});
class ShargeLogoWall extends HTMLElement {
    constructor() {
        super(...arguments);
        this.currentIndex = 0;
        this.disposer = [];
        this.timer = null;
        this.hovering = false;
        this.handleChange = (index) => {
            if (this.currentIndex === index) {
                return;
            }
            const preIndex = this.currentIndex;
            this.currentIndex = index;
            this.tabs[this.currentIndex].setAttribute('aria-current', 'true');
            this.tabs[preIndex].removeAttribute('aria-current');
            this.panels[preIndex].removeAttribute('aria-current');
            this.panels[this.currentIndex].setAttribute('aria-current', 'true');
        };
    }
    get length() {
        return this.tabs.length;
    }
    connectedCallback() {
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs = tabs;
        this.panels = panels;
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].addEventListener('mouseenter', () => {
                this.handleChange(i);
            });
        }
        this.addEventListener('mouseenter', () => {
            this.hovering = true;
        });
        this.addEventListener('mouseleave', () => {
            this.hovering = false;
        });
        if (this.hasAttribute('auto-play')) {
            let duration = parseInt(this.getAttribute('auto-play'));
            if (Number.isNaN(duration)) {
                duration = 3000;
            }
            this.timer = window.setInterval(() => {
                if (this.hovering) {
                    return;
                }
                this.handleChange((this.currentIndex + 1) % this.length);
            }, duration);
            this.disposer.push(() => {
                if (this.timer) {
                    window.clearInterval(this.timer);
                }
            });
        }
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
}
customElements.define('sharge-logo-wall', ShargeLogoWall);
class ShargeFaq extends HTMLElement {
    constructor() {
        super(...arguments);
        this.currentIndex = 0;
    }
    get isMobile() {
        return theme.config.mqlSmall;
    }
    connectedCallback() {
        const list = Array.from(this.querySelectorAll('[role="listitem"]'));
        this.list = list;
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            item.addEventListener('mouseenter', () => {
                // 移动端使用点击
                if (this.isMobile) {
                    return;
                }
                this.active(i);
            });
            const toggleButton = item.querySelector('[aria-label="Toggle"]');
            toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.addEventListener('click', (event) => {
                if (!this.isMobile) {
                    return;
                }
                if (this.currentIndex === i) {
                    // 关闭
                    event.stopPropagation();
                    item.removeAttribute('aria-current');
                }
            });
            item.addEventListener('click', (event) => {
                if (!this.isMobile) {
                    return;
                }
                this.active(i);
            });
        }
    }
    active(index) {
        if (this.currentIndex === index) {
            return;
        }
        const prev = this.list[this.currentIndex];
        this.currentIndex = index;
        this.list[this.currentIndex].setAttribute('aria-current', 'true');
        prev.removeAttribute('aria-current');
    }
}
customElements.define('sharge-faq', ShargeFaq);
var ButtonAnimateDirection;
(function (ButtonAnimateDirection) {
    ButtonAnimateDirection["Left2Right"] = "ltr";
    ButtonAnimateDirection["Right2Left"] = "rtl";
    ButtonAnimateDirection["Top2Bottom"] = "ttb";
    ButtonAnimateDirection["Bottom2Top"] = "btt";
})(ButtonAnimateDirection || (ButtonAnimateDirection = {}));
const shargeButtonShare = function () {
    let fill = this.querySelector('[role="fill"]');
    let overlap = this.querySelector('[role="overlap"]');
    let text = this.querySelector('[role="text"]');
    if (!text) {
        text = document.createElement('span');
        for (const child of Array.from(this.children)) {
            text.appendChild(child.cloneNode(true));
        }
        this.replaceChildren(text);
    }
    if (!overlap) {
        // 如果 overlap 不存在，则创建一个 clone 的 text 元素
        overlap = text.cloneNode(true);
        overlap.setAttribute('role', 'overlap');
        this.appendChild(overlap);
    }
    if (!fill) {
        // 插入 fill 元素
        fill = document.createElement('div');
        fill.setAttribute('role', 'fill');
        fill.style.display = 'block';
        this.appendChild(fill);
    }
    else if (!overlap) {
        return;
    }
    let tl;
    const direction = this.getAttribute('direction') || ButtonAnimateDirection.Bottom2Top;
    const axis = direction === ButtonAnimateDirection.Left2Right || direction === ButtonAnimateDirection.Right2Left
        ? 'translateX'
        : 'translateY';
    const base = direction === ButtonAnimateDirection.Left2Right || direction === ButtonAnimateDirection.Top2Bottom ? -1 : 1;
    const percent = 76;
    let initialed = false;
    const initialFillSize = () => {
        if (initialed) {
            return;
        }
        initialed = true;
        const containerWidth = this.clientWidth;
        const containerHeight = this.clientHeight;
        let fillWidth = containerWidth * 3;
        let fillHeight = containerHeight * 3;
        if (axis === 'translateX') {
            // 水平动画时，椭圆宽高比为 4:3
            const baseSize = Math.max(containerWidth, containerHeight) * 3;
            fillWidth = baseSize;
            fillHeight = baseSize * (3 / 4);
        }
        else {
            // 垂直动画时，椭圆宽高比为 3:4
            const baseSize = Math.max(containerWidth, containerHeight) * 3;
            fillWidth = baseSize * (3 / 4);
            fillHeight = baseSize;
        }
        fill.style.width = `${fillWidth}px`;
        fill.style.height = `${fillHeight}px`;
    };
    fill.style.transform = `${axis}(${base * percent}%)`;
    this.addEventListener('mouseenter', () => {
        initialFillSize();
        if (tl) {
            tl.kill();
        }
        // 创建 timeline，所有动画同时开始
        tl = gsap.timeline({
            onComplete: () => {
                this.setAttribute('aria-hovering', 'true');
            },
        });
        tl.fromTo(text, {
            opacity: 1,
        }, {
            opacity: 0,
            duration: 0.1,
        }, 0 // 从时间点 0 开始
        )
            .fromTo(overlap, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
            onComplete: () => {
                this.setAttribute('aria-hovering', 'true');
            },
        }, 0 // 从时间点 0 开始，与上面动画同时
        )
            .fromTo(fill, {
            [axis]: base * percent + '%',
        }, {
            [axis]: 0,
            duration: 0.5,
        }, 0 // 从时间点 0 开始，与上面动画同时
        );
    });
    this.addEventListener('mouseleave', () => {
        if (tl) {
            tl.kill();
        }
        // 创建 timeline，所有动画同时开始
        tl = gsap.timeline({
            onStart: () => {
                this.removeAttribute('aria-hovering');
            },
        });
        tl.fromTo(overlap, {
            opacity: 1,
        }, {
            opacity: 0,
            duration: 0.1,
        }, 0 // 从时间点 0 开始
        )
            .fromTo(text, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
        }, 0 // 从时间点 0 开始，与上面动画同时
        )
            .to(fill, {
            [axis]: -base * percent + '%',
            duration: 0.5,
        }, 0 // 从时间点 0 开始，与上面动画同时
        );
    });
    const resizeObserver = new ResizeObserver(() => {
        initialed = false;
        initialFillSize();
    });
    resizeObserver.observe(this);
};
class ShargeButton extends HTMLButtonElement {
    connectedCallback() {
        shargeButtonShare.call(this);
    }
}
customElements.define('sharge-button', ShargeButton, { extends: 'button' });
class ShargeButtonLink extends HTMLAnchorElement {
    connectedCallback() {
        shargeButtonShare.call(this);
    }
}
customElements.define('sharge-button-link', ShargeButtonLink, { extends: 'a' });
class ShargeSlideShowButton extends ShargeButton {
    connectedCallback() {
        super.connectedCallback();
        const isNext = this.getAttribute('aria-label') === 'Next';
        const controls = this.getAttribute('aria-controls');
        const slider = document.getElementById(controls);
        if (!slider) {
            console.warn('[sharge-slide-show-button] aria-controls not found', this);
        }
        this.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isNext) {
                slider === null || slider === void 0 ? void 0 : slider.dispatchEvent(new CustomEvent('slider:next'));
            }
            else {
                slider === null || slider === void 0 ? void 0 : slider.dispatchEvent(new CustomEvent('slider:previous'));
            }
        });
    }
}
customElements.define('sharge-slide-show-button', ShargeSlideShowButton, { extends: 'button' });
class ShargeSwatchHoverPreview extends HTMLUListElement {
    connectedCallback() {
        const controls = this.getAttribute('aria-controls');
        const productImage = document.getElementById(controls);
        if (!productImage) {
            return;
        }
        const swatches = Array.from(this.querySelectorAll('.sharge-color-swatch'))
            .map((i) => {
            const img = i.querySelector('.swatch-image');
            if (!img) {
                return null;
            }
            return {
                src: img.src,
                srcset: img.srcset,
                swatch: i,
            };
        })
            .filter((t) => t !== null);
        const sourceImageSrc = productImage.src;
        const sourceImageSrcSet = productImage.srcset;
        let leaveTimeline;
        swatches.forEach((i) => {
            i.swatch.addEventListener('mouseenter', () => {
                leaveTimeline === null || leaveTimeline === void 0 ? void 0 : leaveTimeline.kill();
                gsap
                    .timeline()
                    .to(productImage, {
                    duration: 0.2,
                    opacity: 0,
                    ease: 'power2.inOut',
                    scale: 0.9,
                })
                    .to(productImage, {
                    onStart: () => {
                        productImage.src = i.src;
                        productImage.srcset = i.srcset;
                    },
                    duration: 0.3,
                    opacity: 1,
                    scale: 1,
                    ease: 'power2.inOut',
                });
            });
            i.swatch.addEventListener('mouseleave', () => {
                leaveTimeline = gsap
                    .timeline()
                    .to(productImage, {
                    duration: 0.1,
                    opacity: 0,
                    scale: 0.9,
                })
                    .to(productImage, {
                    onStart: () => {
                        productImage.src = sourceImageSrc;
                        productImage.srcset = sourceImageSrcSet;
                    },
                    duration: 0.3,
                    scale: 1,
                    opacity: 1,
                    onComplete: () => {
                        productImage.style.transform = '';
                    },
                });
            });
        });
    }
}
customElements.define('sharge-swatch-hover-preview', ShargeSwatchHoverPreview, { extends: 'ul' });
class ShargeFeaturedCollectionSlider extends HTMLElement {
    get slideShowElement() {
        return this.querySelector('slideshow-element');
    }
    connectedCallback() {
        const slider = this.slideShowElement;
        if (!slider) {
            console.warn('[sharge-featured-collection-slider] slideshow-element not found', this);
            return;
        }
        const productCards = Array.from(this.querySelectorAll('.sharge-slideshow-product-card'));
        // @ts-expect-error
        slider.addEventListener('slider:change', (e) => {
            const currentPage = e.detail.currentPage;
            for (let i = 0; i < productCards.length; i++) {
                const card = productCards[i];
                if (i === currentPage) {
                    card.setAttribute('aria-current', 'true');
                }
                else {
                    card.removeAttribute('aria-current');
                }
            }
        });
    }
}
customElements.define('sharge-featured-collection-slider', ShargeFeaturedCollectionSlider);
class ShargeHorizontalScrollHint extends HTMLElement {
    constructor() {
        super(...arguments);
        this.disposer = [];
        this.isOverflowing = false;
        this.hasPrevious = false;
        this.hasNext = false;
        this.itemWidth = 0;
    }
    get prevControl() {
        return this.querySelector('[role="previous"]');
    }
    get nextControl() {
        return this.querySelector('[role="next"]');
    }
    connectedCallback() {
        var _a, _b;
        const resizeObserver = new ResizeObserver(() => {
            this.watchOverflow();
        });
        resizeObserver.observe(this);
        this.disposer.push(() => resizeObserver.disconnect());
        this.addEventListener('scrollend', () => {
            this.watchOverflow();
        });
        (_a = this.prevControl) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.scrollTo({
                left: this.scrollLeft - this.itemWidth * 3,
                behavior: 'smooth',
            });
        });
        (_b = this.nextControl) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
            this.scrollTo({
                left: this.scrollLeft + this.itemWidth * 3,
                behavior: 'smooth',
            });
        });
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
    watchOverflow() {
        var _a, _b, _c, _d;
        const scrollWidth = this.scrollWidth;
        const clientWidth = this.clientWidth;
        const scrollLeft = this.scrollLeft;
        this.isOverflowing = scrollWidth > clientWidth;
        this.hasPrevious = this.isOverflowing ? scrollLeft > 0 : false;
        this.hasNext = this.isOverflowing ? scrollLeft < scrollWidth - clientWidth : false;
        this.itemWidth = (_b = (_a = this.firstElementChild) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
        (_c = this.prevControl) === null || _c === void 0 ? void 0 : _c.setAttribute('aria-disabled', this.hasPrevious ? 'false' : 'true');
        (_d = this.nextControl) === null || _d === void 0 ? void 0 : _d.setAttribute('aria-disabled', this.hasNext ? 'false' : 'true');
    }
}
customElements.define('sharge-horizontal-scroll-hint', ShargeHorizontalScrollHint);
class ShargeHeader extends HTMLElement {
    connectedCallback() {
        document.addEventListener('page:loaded', () => {
            const container = this.closest('.shopify-section');
            const mainContent = document.querySelector('#MainContent');
            if (!mainContent)
                return;
            const firstSection = mainContent.firstElementChild;
            if (!firstSection)
                return;
            const paddingTop = getComputedStyle(firstSection).getPropertyValue('--section-padding-top');
            let paddingValue = parseInt(paddingTop);
            if (Number.isNaN(paddingValue))
                return;
            // 不是全屏才加上 padding-top
            if (paddingValue > 0) {
                paddingValue = paddingValue + container.clientHeight;
                firstSection.style.setProperty('--section-padding-top', `${paddingValue}px`);
            }
        });
    }
}
customElements.define('sharge-header', ShargeHeader, { extends: 'header' });
class ShargeAnchors extends HTMLElement {
    constructor() {
        super(...arguments);
        this.isOverflowing = false;
        this.hasPrevious = false;
        this.hasNext = false;
        this.disposer = [];
        this.animation = null;
        this.anchors = [];
        this.currentActiveIndex = -1;
        this.left = null;
    }
    connectedCallback() {
        // 滚动点击
        const left = (this.left = this.querySelector('[aria-label="Previous"]'));
        const right = this.querySelector('[aria-label="Next"]');
        if (left) {
            left.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.scrollTo({
                    left: this.scrollLeft - window.innerWidth / 2,
                    behavior: 'smooth',
                });
            });
        }
        if (right) {
            right.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.scrollTo({
                    left: this.scrollLeft + window.innerWidth / 2,
                    behavior: 'smooth',
                });
            });
        }
        // 监听滚动
        this.addEventListener('scrollend', () => {
            this.watchOverflow();
        });
        const resizeObserver = new ResizeObserver(() => {
            this.watchOverflow();
        });
        resizeObserver.observe(this);
        this.disposer.push(() => resizeObserver.disconnect());
        // 监听滚动事件来确定当前活跃的锚点
        const handleScroll = () => {
            this.updateActiveAnchor();
        };
        // 使用 throttle 来优化性能
        let scrollTimeout = null;
        const throttledScroll = () => {
            if (scrollTimeout)
                return;
            scrollTimeout = requestAnimationFrame(() => {
                handleScroll();
                scrollTimeout = null;
            });
        };
        window.addEventListener('scroll', throttledScroll);
        this.disposer.push(() => window.removeEventListener('scroll', throttledScroll));
        // 监听窗口大小变化，重新计算锚点位置
        const handleResize = () => {
            this.updateAnchorPositions();
            this.updateActiveAnchor();
        };
        window.addEventListener('resize', handleResize);
        this.disposer.push(() => window.removeEventListener('resize', handleResize));
        const handleLoad = () => {
            this.findTargets();
            this.animateHeader();
        };
        // add to cart button
        const button = this.querySelector('button[data-is-add-to-cart]');
        if (button) {
            // get form id
            const form = document.querySelector('form[is="product-form"]');
            if (form) {
                button.setAttribute('form', form.getAttribute('id'));
            }
        }
        if (Shopify.designMode) {
            const watchTarget = (e) => {
                var _a, _b;
                (_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.scrollTrigger) === null || _b === void 0 ? void 0 : _b.refresh();
                const target = e.target;
                if (!target)
                    return;
                if (target.classList.contains('sharge-anchor-target')) {
                    this.findTargets();
                }
            };
            document.addEventListener('shopify:section:load', watchTarget);
            document.addEventListener('shopify:section:unload', watchTarget);
            document.addEventListener('shopify:section:select', watchTarget);
            document.addEventListener('shopify:section:deselect', watchTarget);
            document.addEventListener('shopify:section:reorder', watchTarget);
            this.disposer.push(() => {
                document.removeEventListener('shopify:section:load', watchTarget);
                document.removeEventListener('shopify:section:unload', watchTarget);
                document.removeEventListener('shopify:section:select', watchTarget);
                document.removeEventListener('shopify:section:deselect', watchTarget);
            });
            handleLoad();
        }
        else {
            document.addEventListener('page:loaded', handleLoad);
        }
    }
    disconnectedCallback() {
        this.disposer.forEach((d) => d());
    }
    async animateHeader() {
        const scrollTriggerSrc = this.getAttribute('data-scroll-trigger-src');
        if (!scrollTriggerSrc) {
            throw new Error('scroll-trigger-src is required');
        }
        // 按需加载 ScrollTrigger
        const { ScrollTrigger } = await import('gsap/ScrollTrigger');
        gsap.registerPlugin(ScrollTrigger);
        const header = document.querySelector('.sharge-header-section');
        if (!header)
            return;
        this.animation = gsap.fromTo(header, {
            y: 0,
        }, {
            y: -header.offsetHeight,
            ease: 'none',
            scrollTrigger: {
                trigger: this,
                // markers: true,
                start: () => `top top+=${header === null || header === void 0 ? void 0 : header.offsetHeight}`,
                end: 'top top',
                scrub: true,
                fastScrollEnd: true,
            },
        });
        this.disposer.push(() => {
            var _a;
            (_a = this.animation) === null || _a === void 0 ? void 0 : _a.kill();
        });
    }
    findTargets() {
        var _a;
        const sections = document.querySelectorAll('.sharge-anchor-target');
        const fragment = document.createDocumentFragment();
        const slot = this.querySelector('[role="list"]');
        if (sections.length === 0 && !Shopify.designMode) {
            this.style.display = 'none';
            (_a = this.animation) === null || _a === void 0 ? void 0 : _a.kill();
            return;
        }
        // 收集锚点信息
        this.anchors = [];
        sections.forEach((section) => {
            var _a;
            const anchor = section.firstElementChild;
            this.anchors.push({
                element: anchor,
                offsetTop: this.getOffsetTopToDocument(anchor),
                id: section.id,
            });
            const a = document.createElement('a');
            a.textContent = (_a = anchor.getAttribute('aria-label')) !== null && _a !== void 0 ? _a : '';
            a.href = `#${anchor.id}`;
            a.setAttribute('role', 'listitem');
            a.setAttribute('aria-current', 'false');
            a.setAttribute('aria-controls', section.id);
            a.classList.add('aria-[current=true]:text-brand');
            fragment.appendChild(a);
            if (Shopify.designMode) {
                a.addEventListener('click', (e) => {
                    e.preventDefault();
                    // 激活 section？
                    anchor.closest('.shopify-section').focus();
                });
            }
            else {
                a.addEventListener('click', (e) => {
                    e.preventDefault();
                    const offsetTopToDocument = this.getOffsetTopToDocumentWithHeader(anchor);
                    // 使用手动滚动到精确位置
                    window.scrollTo({
                        top: offsetTopToDocument,
                        behavior: 'smooth',
                    });
                });
            }
        });
        // clean up
        const children = Array.from(slot.children);
        children.forEach((child) => {
            slot.removeChild(child);
        });
        slot.appendChild(fragment);
        // 初始更新锚点位置和活跃状态
        this.updateAnchorPositions();
        this.updateActiveAnchor();
    }
    /**
     * 更新所有锚点的位置信息
     */
    updateAnchorPositions() {
        this.anchors.forEach((anchor) => {
            anchor.offsetTop = this.getOffsetTopToDocument(anchor.element);
        });
    }
    /**
     * 根据当前滚动位置更新活跃的锚点
     */
    updateActiveAnchor() {
        if (this.anchors.length === 0)
            return;
        const scrollTop = window.pageYOffset;
        const headerHeight = this.offsetHeight;
        const currentScrollPosition = scrollTop + headerHeight + 50; // 增加一些缓冲区
        // 找到当前应该激活的锚点
        // 算法：找到最后一个位置小于等于当前滚动位置的锚点
        let activeIndex = 0;
        for (let i = this.anchors.length - 1; i >= 0; i--) {
            if (this.anchors[i].offsetTop <= currentScrollPosition) {
                activeIndex = i;
                break;
            }
        }
        // 如果活跃索引没有变化，直接返回
        if (this.currentActiveIndex === activeIndex)
            return;
        this.currentActiveIndex = activeIndex;
        // 更新 UI
        const anchorLinks = this.querySelectorAll('a[role="listitem"]');
        anchorLinks.forEach((link, index) => {
            const isActive = index === activeIndex;
            link.setAttribute('aria-current', String(isActive));
            // 如果是新激活的锚点，滚动到可视区域
            if (isActive) {
                requestAnimationFrame(() => {
                    var _a, _b;
                    const anchorElement = link;
                    const anchorLeft = anchorElement.offsetLeft;
                    const padding = (_b = (_a = this.left) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0;
                    this.scrollTo({
                        left: anchorLeft - padding - 10,
                        behavior: 'smooth',
                    });
                });
            }
        });
    }
    watchOverflow() {
        const scrollWidth = this.scrollWidth;
        const clientWidth = this.clientWidth;
        this.isOverflowing = scrollWidth > clientWidth;
        this.hasPrevious = this.isOverflowing ? this.scrollLeft > 0 : false;
        this.hasNext = this.isOverflowing ? this.scrollLeft < scrollWidth - clientWidth : false;
        this.classList.toggle('overflowing', this.isOverflowing);
        this.classList.toggle('has-previous', this.hasPrevious);
        this.classList.toggle('has-next', this.hasNext);
    }
    /**
     * 计算元素相对于文档顶部的偏移量
     * @param element 目标元素
     * @returns 偏移量（像素）
     */
    getOffsetTopToDocument(element) {
        let offsetTop = 0;
        let currentElement = element.parentElement;
        while (currentElement) {
            offsetTop += currentElement.offsetTop;
            currentElement = currentElement.offsetParent;
        }
        return offsetTop;
    }
    /**
     * 计算元素相对于文档顶部的偏移量，考虑页面头部高度
     * @param element 目标元素
     * @returns 调整后的偏移量（像素）
     */
    getOffsetTopToDocumentWithHeader(element) {
        const offsetTop = this.getOffsetTopToDocument(element);
        return offsetTop - this.offsetHeight;
    }
}
customElements.define('sharge-anchors', ShargeAnchors);
class ShargeHideIfNextEmpty extends HTMLDivElement {
    constructor() {
        super(...arguments);
        this.observer = null;
        this.debounceTimer = null;
    }
    connectedCallback() {
        // 初始检查
        const isEmpty = this.checkNextElement();
        // 假设兄弟级别的一层结构是稳定的
        if (isEmpty) {
            this.setupObserver();
        }
    }
    disconnectedCallback() {
        // 清理资源
        this.cleanup();
    }
    checkNextElement() {
        const nextElement = this.nextElementSibling;
        if (nextElement && nextElement.nodeType === 1) {
            const isEmpty = this.isElementEmpty(nextElement);
            this.style.visibility = isEmpty ? 'hidden' : 'visible';
            return isEmpty;
        }
        else {
            // 没有下一个元素，保持显示
            this.style.visibility = 'visible';
            return false;
        }
    }
    isElementEmpty(element) {
        var _a;
        // 检查元素是否为空
        return (element.children.length === 0 ||
            (element.childElementCount === 1 && ((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.children.length) === 0));
    }
    setupObserver() {
        // 清理旧的观察器
        if (this.observer) {
            this.observer.disconnect();
        }
        const nextElement = this.nextElementSibling;
        if (!nextElement)
            return;
        // 创建新的观察器，只监听下一个兄弟元素
        this.observer = new MutationObserver((mutations) => {
            // 使用 debounce 优化性能
            if (this.debounceTimer) {
                window.clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = window.setTimeout(() => {
                // 检查是否有相关的变化
                const hasRelevantChange = mutations.some((mutation) => mutation.type === 'childList');
                if (hasRelevantChange) {
                    this.checkNextElement();
                }
            }, 10); // 10ms debounce
        });
        // 观察下一个元素的子元素变化和文本内容变化
        this.observer.observe(nextElement, {
            childList: true,
            subtree: false,
            characterData: false,
        });
    }
    cleanup() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        if (this.debounceTimer) {
            window.clearTimeout(this.debounceTimer);
            this.debounceTimer = null;
        }
    }
}
customElements.define('sharge-hide-if-next-empty', ShargeHideIfNextEmpty, { extends: 'div' });
const requestIdleCallback = typeof window.requestIdleCallback === 'function' ? window.requestIdleCallback : setTimeout;
class DeclarativeShadowElement extends HTMLElement {
    connectedCallback() {
        if (!this.shadowRoot) {
            const template = this.querySelector(':scope > template[shadowrootmode="open"]');
            if (!(template instanceof HTMLTemplateElement))
                return;
            const shadow = this.attachShadow({ mode: 'open' });
            shadow.append(template.content.cloneNode(true));
        }
    }
}
/**
 * 基础组件类，为自定义 Web 组件提供核心功能
 *
 * 管理具有 `ref` 属性的子元素引用，设置变异观察器以保持
 * refs 在 DOM 更改时保持更新。还处理声明性事件监听器。
 */
export class Component extends DeclarativeShadowElement {
    /**
     * 获取组件的根节点，可能是其 shadow root 或组件本身
     */
    get roots() {
        return this.shadowRoot ? [this, this.shadowRoot] : [this];
    }
    constructor() {
        super();
        /**
         * 持有具有 `ref` 属性的子元素引用的对象
         */
        this.refs = {};
        /**
         * 检查给定节点是否是此组件的后代
         */
        this.isDescendant = (node) => getClosestComponent(getAncestor(node)) === this;
        this.mutationObserver = new MutationObserver((mutations) => {
            if (mutations.some((m) => (m.type === 'attributes' && this.isDescendant(m.target)) ||
                (m.type === 'childList' &&
                    [...Array.from(m.addedNodes), ...Array.from(m.removedNodes)].some((node) => this.isDescendant(node))))) {
                this.updateRefs();
            }
        });
    }
    /**
     * 当元素连接到文档的 DOM 时调用
     *
     * 初始化事件监听器和 refs
     */
    connectedCallback() {
        super.connectedCallback();
        registerEventListeners();
        this.updateRefs();
        requestIdleCallback(() => {
            for (const root of this.roots) {
                this.mutationObserver.observe(root, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['ref'],
                    attributeOldValue: true,
                });
            }
        });
    }
    /**
     * 当元素被 Section Rendering API 重新渲染时调用
     */
    updatedCallback() {
        this.mutationObserver.takeRecords();
        this.updateRefs();
    }
    /**
     * 当元素从文档的 DOM 断开连接时调用
     *
     * 断开变异观察器
     */
    disconnectedCallback() {
        this.mutationObserver.disconnect();
    }
    /**
     * 通过查询所有具有 `ref` 属性的后代元素并存储对它们的引用来更新 `refs` 对象
     *
     * 调用此方法以使 `refs` 对象与 DOM 保持同步
     */
    updateRefs() {
        var _a, _b;
        const refs = {};
        const elements = this.roots.reduce((acc, root) => {
            for (const element of Array.from(root.querySelectorAll('[ref]'))) {
                if (!this.isDescendant(element))
                    continue;
                acc.add(element);
            }
            return acc;
        }, new Set());
        for (const ref of elements) {
            const refName = (_a = ref.getAttribute('ref')) !== null && _a !== void 0 ? _a : '';
            const isArray = refName.endsWith('[]');
            const path = isArray ? refName.slice(0, -2) : refName;
            if (isArray) {
                const array = Array.isArray(refs[path]) ? refs[path] : [];
                array.push(ref);
                refs[path] = array;
            }
            else {
                refs[path] = ref;
            }
        }
        if ((_b = this.requiredRefs) === null || _b === void 0 ? void 0 : _b.length) {
            for (const ref of this.requiredRefs) {
                if (!(ref in refs)) {
                    throw new MissingRefError(ref, this);
                }
            }
        }
        this.refs = refs;
    }
}
/**
 * 获取给定节点的祖先
 */
function getAncestor(node) {
    if (node.parentNode)
        return node.parentNode;
    const root = node.getRootNode();
    if (root instanceof ShadowRoot)
        return root.host;
    return null;
}
/**
 * 递归查找最近的 `Component` 实例祖先
 */
function getClosestComponent(node) {
    if (!node)
        return null;
    if (node instanceof Component)
        return node;
    if (node instanceof HTMLElement && node.tagName.toLowerCase().endsWith('-component'))
        return node;
    const ancestor = getAncestor(node);
    if (ancestor)
        return getClosestComponent(ancestor);
    return null;
}
/**
 * 初始化自定义事件处理的事件监听器
 */
let initialized = false;
function registerEventListeners() {
    if (initialized)
        return;
    initialized = true;
    const events = ['click', 'change', 'select', 'focus', 'blur', 'submit', 'input', 'keydown', 'keyup', 'toggle'];
    const shouldBubble = ['focus', 'blur'];
    const expensiveEvents = ['pointerenter', 'pointerleave'];
    for (const eventName of [...events, ...expensiveEvents]) {
        const attribute = `on:${eventName}`;
        document.addEventListener(eventName, (event) => {
            var _a, _b;
            const element = getElement(event);
            if (!element)
                return;
            const proxiedEvent = event.target !== element
                ? new Proxy(event, {
                    get(target, property) {
                        if (property === 'target')
                            return element;
                        const value = Reflect.get(target, property);
                        if (typeof value === 'function') {
                            return value.bind(target);
                        }
                        return value;
                    },
                })
                : event;
            const value = (_a = element.getAttribute(attribute)) !== null && _a !== void 0 ? _a : '';
            let [selector, method] = value.split('/');
            // 提取由 `?` 或 `/` 分隔的属性值的最后一段
            const data = (_b = value.match(/(?<=[\/\?][^\/\?]+)[\/\?][^\/\?]+$/)) === null || _b === void 0 ? void 0 : _b[0];
            const instance = selector
                ? selector.startsWith('#')
                    ? document.querySelector(selector)
                    : element.closest(selector)
                : getClosestComponent(element);
            if (!(instance instanceof Component) || !method)
                return;
            method = method.replace(/\?.*/, '');
            const callback = instance[method];
            if (typeof callback === 'function') {
                try {
                    const args = [proxiedEvent];
                    if (data)
                        args.unshift(parseData(data));
                    // @ts-expect-error
                    callback.call(instance, ...args);
                }
                catch (error) {
                    console.error(error);
                }
            }
        }, { capture: true });
    }
    function getElement(event) {
        var _a, _b, _c;
        const target = (_c = (_b = (_a = event).composedPath) === null || _b === void 0 ? void 0 : _b.call(_a)[0]) !== null && _c !== void 0 ? _c : event.target;
        if (!(target instanceof Element))
            return null;
        if (target.hasAttribute(`on:${event.type}`)) {
            return target;
        }
        if (expensiveEvents.includes(event.type)) {
            return null;
        }
        return event.bubbles || shouldBubble.includes(event.type) ? target.closest(`[on\\:${event.type}]`) : null;
    }
}
/**
 * 基于分隔符解析字符串以提取数据
 */
function parseData(str) {
    const delimiter = str[0];
    const data = str.slice(1);
    return delimiter === '?'
        ? Object.fromEntries(Array.from(new URLSearchParams(data).entries()).map(([key, value]) => [key, parseValue(value)]))
        : parseValue(data);
}
/**
 * 将字符串值解析为其适当的类型
 */
function parseValue(str) {
    if (str === 'true')
        return true;
    if (str === 'false')
        return false;
    const maybeNumber = Number(str);
    if (!isNaN(maybeNumber) && str.trim() !== '')
        return maybeNumber;
    return str;
}
/**
 * 当在组件中找不到所需的 ref 时抛出格式化错误
 */
export class MissingRefError extends Error {
    constructor(ref, component) {
        super(`Required ref "${ref}" not found in component ${component.tagName.toLowerCase()}`);
    }
}
/**
 * 渲染视频背景的自定义元素
 */
export class VideoBackgroundComponent extends Component {
    constructor() {
        super(...arguments);
        this.requiredRefs = ['videoSources', 'videoElement'];
    }
    connectedCallback() {
        super.connectedCallback();
        const { videoSources, videoElement } = this.refs;
        for (const source of videoSources) {
            const { videoSource } = source.dataset;
            if (videoSource)
                source.setAttribute('src', videoSource);
        }
        videoElement.load();
    }
}
if (!customElements.get('video-background-component')) {
    customElements.define('video-background-component', VideoBackgroundComponent);
}
